<template>
  <v-container>
    <v-autocomplete
      v-model="selectedBusiness"
      :items="businessTypes"
      item-text="text_fa"
      item-value="value_en"
      label="نوع کسب‌وکار"
      outlined
      return-object
      no-data-text="گزینه‌ای یافت نشد. برای افزودن تایپ کنید."
      dense
      :search-input.sync="search"
      @change="handleBusinessSelection"
      @update:search-input="handleSearchInput"
      append-icon="mdi-plus"
      @click:append="addNewBusiness"
    >
      <template v-slot:item="{ item }">
        <v-icon>{{ item.icon }}</v-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.text_fa }}</v-list-item-title>
          <!-- <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle> -->
        </v-list-item-content>
      </template>
      <template v-slot:selection="{ item }">
        <v-icon left>{{ item.icon }}</v-icon>
        {{ item.text_fa }}
      </template>
    </v-autocomplete>
  </v-container>
</template>

<script>
import businessTypes from "./businessTypes.json";

export default {
  data() {
    return {
      selectedBusiness: null,
      businessTypes,
      search: "",
    };
  },
  watch: {
    selectedBusiness(newVal) {
      if (newVal) {
        this.handleBusinessSelection(newVal);
      }
    },
  },
  methods: {
    handleBusinessSelection(item) {
      if (item) {
        this.$emit("updateBusiness", item.text_fa);
      }
    },
    conso() {
      console.log("data", this.selectedBusiness);
    },
    handleSearchInput(value) {
      this.search = value;
    },
    addNewBusiness() {
      if (this.search && this.search.trim() !== "") {
        const isDuplicate = this.businessTypes.some(
          (item) => item.text_fa === this.search.trim(),
        );

        if (!isDuplicate) {
          const newBusiness = {
            text_fa: this.search.trim(),
            value_en: this.search.trim().replace(/\s+/g, "_"),
          };
          this.businessTypes.push(newBusiness);
          this.selectedBusiness = newBusiness;
          this.$emit("updateBusiness", newBusiness.text_fa);
          this.search = "";
        } else {
          this.$taost.warn("این نوع کسب‌وکار قبلاً وجود داشته است!");
        }
      }
    },
  },
};
</script>

<style scoped></style>
